<template>
  <v-btn
    color="primary"
    plain
    elevation="0"
    :loading="loading"
    @click="$emit('click')"
  >
    <v-icon
      class="mr-2"
      color="primary"
    >
      {{ icon }}
    </v-icon>
    {{ label }}
  </v-btn>
</template>

<script>

export default {
  name: 'InfoPaneActionBtn',
  props: {
    loading: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    label: { type: String, required: true }
  },
  emits: ['click']
}
</script>
<style lang="scss" scoped></style>
